import { set } from 'cerebral/operators'

export default [
  set('state:app.showUserNotAgreedOnDBPRTerms', false),
  set('state:login.showGDPRDialog', true)
]



// WEBPACK FOOTER //
// ./src/modules/app/chains/redoGDRP.js